import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ICustomConfigurationRepository } from '../../repositories/interfaces/iCustomConfigurationRepository';
import { IGetHeaderMenuResponse } from '../../../entity/interface/IGetHeaderMenu';

export interface IGetHeaderMenuContentUseCase {
    execute(): Promise<IGetHeaderMenuResponse>;
}

export class GetHeaderMenuContentUseCase implements IGetHeaderMenuContentUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get customConfigurationRepository(): ICustomConfigurationRepository {
        return container.resolve<ICustomConfigurationRepository>(DI.REPOSITORIES.ICustomConfigurationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<IGetHeaderMenuResponse> {
        const response = await this.customConfigurationRepository.getHeaderMenuContent();
        return response;
    }
}
